import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useMobile } from '../common/hooks/use-mobile';
import { transformPageMargins, transformUnit } from '../common/utils';
export default function Divider(props) {
  var mode = props.mode,
    blankSpace = props.blankSpace,
    blankColor = props.blankColor,
    lineStyle = props.lineStyle,
    pagePadding = props.pagePadding,
    lineColor = props.lineColor;
  var mobile = useMobile();
  return _jsx("div", Object.assign({
    className: 'flex items-center w-full',
    style: {
      paddingLeft: transformPageMargins(pagePadding, mobile),
      paddingRight: transformPageMargins(pagePadding, mobile),
      height: transformUnit(blankSpace, mobile),
      backgroundColor: blankColor
    }
  }, {
    children: (mode === 'line' || mode === 1) && _jsx("div", {
      className: classNames('w-full border-t-[1px]', {
        'border-solid': lineStyle === 'solid',
        'border-dashed': lineStyle === 'dashed',
        'border-dotted': lineStyle === 'dotted'
      }),
      style: {
        borderColor: lineColor
      }
    })
  }));
}